import { List, Switch } from "@mui/material";
import { CloseGreyIcon } from "../../../assets/icons";
import { TableShapeType } from "../../../models/base/TableShapeType";
import { useState } from "react";
import { CreateTableDTO } from "../../../models/table/table.request";
import { TableStatusType } from "../../../models/base/TableStatusType";
import { useNotification } from "../../toster-notification/NotificationContext";
import { useParams } from "react-router-dom";
import { tableService } from "../../../services/tableService";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import Loader from "../../shared/Loader";

interface AddTableViewProps {
    onClose: () => void;
}

const AddTableView: React.FC<AddTableViewProps> = ({ onClose }) => {

    const [tableData, setTableData] = useState<CreateTableDTO>({
        number: 0,
        capacity: 0,
        shape: TableShapeType.Rectangle,
        isActive: true,
        isReservable: true,
        description: "",
        xCordinatePercentage: 0,
        yCordinatePercentage: 0,
        widthPercentage: 0,
        heightPercentage: 0
    });

    const [numberError, setNumberError] = useState<string | null>(null);
    const [capacityError, setCapacityError] = useState<string | null>(null);
    const [shapeError, setShapeError] = useState<string | null>(null);

    const tableShapes: Record<string, TableShapeType> = {};

    const [loading, setLoading] = useState(false);

    const { notify } = useNotification();

    const { localId } = useParams<{ localId: string }>();


    const handleCreateTable = async () => {
        if (!localId) {
            notify("error", "Local ID is required to create a table.");
            return;
        }

        let valid = true;

        if (tableData.number <= 0) {
            setNumberError("Broj stola mora biti veći od 0.");
            valid = false;
        }

        if (tableData.capacity <= 0) {
            setCapacityError("Kapacitet mora biti veći od 0.");
            valid = false;
        }

        if (!tableData.shape && tableData.shape !== 0) {
            setShapeError("Oblik stola je obavezan.");
            valid = false;
        }

        if (!valid) {
            return;
        }

        setLoading(true);
        try {
            const response = await tableService.createTable(localId, tableData);

            if (response.success) {
                notify("success", "Sto je uspešno dodat.");
                onClose();
            } else {
                notify("error", response.message || "Došlo je do greške prilikom dodavanja stola.");
            }
        } catch (error: any) {
            notify("error", "Došlo je do greške prilikom dodavanja stola.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    }

    for (const shape in TableShapeType) {
        if (isNaN(Number(shape))) {
            tableShapes[shape] = TableShapeType[shape as keyof typeof TableShapeType];
        }
    }


    if (loading) {
        return <Loader />
    }


    return (
        <section className="modal-section category">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Dodaj novi sto</div>
                                <div className="description-text">Unesite informacije o stolu</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Broj stola *</label>
                                    <input className="form-input grey w-input" placeholder="Unesite broj stola" type="number" min={1}
                                        value={tableData?.number}
                                        onChange={(e) => setTableData({ ...tableData, number: Number(e.target.value) })}
                                    />
                                    <div className="error-text">{numberError}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Kapacitet (mesta) *</label>
                                    <input className="form-input grey w-input" placeholder="Unesite kapacitet" type="number" min={1}
                                        value={tableData?.capacity}
                                        onChange={(e) => setTableData({ ...tableData, capacity: Number(e.target.value) })}
                                    />
                                    <div className="error-text">{capacityError}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Oblik stola</label>

                                    <select className="form-select auto-width w-select"
                                        value={tableData?.shape}
                                        onChange={(e) => setTableData({ ...tableData, shape: Number(e.target.value) as TableShapeType })}
                                    >
                                        <option value="">Izaberite oblik...</option>

                                        {Object.entries(tableShapes).map(([key, value]) => (
                                            <option key={key} value={value}>
                                                {key}
                                            </option>
                                        ))}

                                    </select>
                                    <div className="error-text">{shapeError}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Napomena</label>
                                    <textarea placeholder="Opciono unesite napomenu (npr. blizu prozora)" className="form-textarea grey w-input"
                                        value={tableData?.description}
                                        onChange={(e) => setTableData({ ...tableData, description: e.target.value })}
                                    ></textarea>
                                </div>

                                <div className="modal-form-div f-horizontal">
                                    <label className="modal-form-label">Aktivan sto *</label>
                                    <Switch
                                        checked={tableData?.isActive}
                                        onChange={(e) => setTableData({ ...tableData, isActive: e.target.checked })}
                                    />
                                </div>

                                <div className="modal-form-div f-horizontal">
                                    <label className="modal-form-label">Moguće rezervisati *</label>
                                    <Switch
                                        checked={tableData?.isReservable}
                                        onChange={(e) => setTableData({ ...tableData, isReservable: e.target.checked })}
                                    />
                                </div>

                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={() => handleCreateTable()}>
                                <div>Dodaj sto</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );

};

export default AddTableView;